import styled from 'styled-components';

import { HideContainer } from '@components/hide-container';
import { InfoBox } from '@components/info-box';
import { Sidebar } from '@components/sidebar';
import { useScopedTranslate } from '@locale/translate';

import { TravellerJourneyActionDetailed } from 'api/types';

import { sidebarLocale } from './traveller-sidebar-locale';

export const hasErrorResponse = (action: TravellerJourneyActionDetailed<'integration'>) =>
  action.status !== 'completed' && action.result?.status === 'error';

export const ErrorResponseSection = ({
  action,
}: {
  action: TravellerJourneyActionDetailed<'integration'>;
}) => {
  const { t } = useScopedTranslate(sidebarLocale);
  if (!hasErrorResponse(action)) return null;
  return (
    <>
      <Sidebar.Separator />
      <HideContainer title={t('errorResponse')}>
        <InfoBox variant="red">
          <CodeBlock>{JSON.stringify(action.result?.validationError, null, 2)}</CodeBlock>
        </InfoBox>
      </HideContainer>
    </>
  );
};

// InfoBox colours its text through a `span` selector; a `pre` would keep the
// default text colour (invisible in dark mode) and its browser margins.
const CodeBlock = styled.span({
  display: 'block',
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
  fontFamily: 'ui-monospace, SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace',
});
